import { styled as r, Button as C, Box as h, List as _, Accordion as S, Typography as i, Chip as L, Fade as T, ListItem as v, AccordionSummary as $, AccordionDetails as z } from "@mui/material";
import { ScreenLogType as c } from "../../../constants/screenLog.js";
import { useScreenLogContext as I } from "../../../contexts/share/ScreenLogContext.js";
import A from "../../../hooks/generic/useCSR.js";
import { noForwardProps as g } from "../../../util/styled/index.js";
import * as B from "ramda";
import { useCallback as F } from "react";
import { jsxs as n, Fragment as d, jsx as o } from "react/jsx-runtime";
const O = r(C, g)`
  aspect-ratio: 1;
  background-color: #33333399;
  border-radius: 50px;
  bottom: 20px;
  color: white;
  font-size: 30px;
  font-weight: 300;
  padding: unset;
  position: fixed;
  right: 120px;
  width: 50px;
  z-index: 9999;
  ${(e) => e.__open && "filter: grayscale(100%);"}
  :hover {
    background-color: #333;
  }
`, R = r(h)`
  background-color: rgba(0, 0, 0, 0.7);
  border-top-left-radius: 20px;
  bottom: 0px;
  padding-top: 10px;
  position: fixed;
  right: 0px;
  z-index: 9999;
`, j = r(_)`
  height: 50vh;
  max-height: 500px;
  max-width: 600px;
  overflow-y: auto;
  width: 100vw;
`, D = r(S)`
  width: 100%;
`, q = r(i)`
  color: #333;
`, G = r(h)`
  display: flex;
  align-items: center;
`, M = r(L, g)`
  ${(e) => {
  switch (e.__type) {
    case c.Graphql:
      return "background-color: #3968cc;";
    case c.Contract:
      return "background-color: purple;";
    case c.Manual:
      return "background-color: #1da05f;";
    default:
      return "background-color: light-gray;";
  }
}}
`, s = r(i)`
  color: #333;
`, x = r(i)`
  color: black;
`, P = r(x)`
  padding-top: 10px;
`, u = r(i)`
  background-color: #eee;
  border-radius: 6px;
  color: #aaa;
  font-size: 14px;
  overflow-x: auto;
  padding: 8px;
  white-space: pre;
`, V = () => {
  const {
    logs: e,
    open: t,
    setOpen: l
  } = I(), m = A(), f = F(() => {
    l(!t);
  }, [t, l]);
  return m ? /* @__PURE__ */ n(d, {
    children: [t && /* @__PURE__ */ o(T, {
      in: !0,
      children: /* @__PURE__ */ o(R, {
        children: /* @__PURE__ */ o(j, {
          children: B.map((b) => {
            const {
              operation: y,
              type: a,
              index: p,
              input: w,
              output: k
            } = b;
            return /* @__PURE__ */ o(v, {
              children: /* @__PURE__ */ n(D, {
                children: [/* @__PURE__ */ o($, {
                  expandIcon: /* @__PURE__ */ o(q, {
                    children: "►"
                  }),
                  children: /* @__PURE__ */ n(G, {
                    children: [/* @__PURE__ */ o(M, {
                      __type: a,
                      label: a
                    }), /* @__PURE__ */ o(s, {
                      children: "  "
                    }), /* @__PURE__ */ o(s, {
                      children: `(${p}) ${y}`
                    })]
                  })
                }), /* @__PURE__ */ n(z, {
                  children: [/* @__PURE__ */ o(x, {
                    children: "▎input"
                  }), /* @__PURE__ */ o(u, {
                    children: w
                  }), /* @__PURE__ */ o(P, {
                    children: "▎output"
                  }), /* @__PURE__ */ o(u, {
                    children: k
                  })]
                })]
              })
            }, `log_${p}`);
          }, e)
        })
      })
    }), /* @__PURE__ */ o(O, {
      __open: t,
      onClick: f,
      children: "👾"
    })]
  }) : /* @__PURE__ */ o(d, {});
};
export {
  V as default
};
//# sourceMappingURL=ScreenLogger.js.map
